import React from "react";
import PageLayout from "../../../../components/page/PageLayout";
import SignInBannerWithState from "../../auth/SignInBannerWithState";
import LandingLayout from "../../home/landingLayout/LandingLayout";
import useSession from "../../../services/state/session/useSession";
import PartnerHome from "../../home/partnerHome/PartnerHome";
import DeliveryCountDown from "../../../delivery/countDown/DeliveryCountDown";
import AppPromotion from "../../../promotion/AppPromotion";

const PageHome = () => {

    const session = useSession();

    return (
        <>
            <PageLayout>
                <AppPromotion />
                <SignInBannerWithState/>
                {session.isSignedIn ?
                    <PartnerHome/> :
                    <LandingLayout/>
                }
                <DeliveryCountDown/>
            </PageLayout>
        </>
    )
}

export default PageHome;
